import { normalize } from 'normalizr'

import { createDenormalizedSelector } from '../entities/selectors'
import { locationSchema } from '../sfproxy/schemas'
import { pendingSelector } from 'api/selectors'

import { googleLocationSchema } from './schemas'
import * as constants from './constants'

export const searchSelector = state => state.locationSearch

const resultsSelector = createSelector(searchSelector, search => search.results)
const googleResultsSelector = createSelector(searchSelector, search => search.googleResults)
const selectedLocationSelector = createSelector(searchSelector, search => search.location || {})
export const locationValueSelector = createSelector(selectedLocationSelector, location => location.value)
export const selectedLocationTitleSelector = createSelector(selectedLocationSelector, location => location.label)

export const locationSearchPendingSelector = createSelector(pendingSelector, pending => pending.locations || false)

const locationsSelector = createDenormalizedSelector(resultsSelector, [locationSchema])

const googleLocationsSelector = createDenormalizedSelector(googleResultsSelector, [googleLocationSchema])

const getIsBookable = (bookableMode, location) => {
    switch (bookableMode) {
        case constants.BOOKABLE_SEASON_TICKET_ONLY:
            return location.seasonTicketsEnabled
        case constants.BOOKABLE_RESERVATION_ONLY:
            return location.reservationsEnabled
        default:
            return location.reservationsEnabled || location.seasonTicketsEnabled
    }
}

export const locationsListSelector = createSelector(
    [locationsSelector, (state, bookableMode) => bookableMode],
    (locations, bookableMode) =>
        locations.map(location => {
            const brand = location.brand.toLowerCase()
            const isBookable = getIsBookable(bookableMode, location)
            const bookability = `${isBookable ? 'bookable' : 'unbookable'}`

            const getIcon = () => {
                if (location.opngo) {
                    return 'pin-opngo'
                }

                if (brand === 'indigo' || brand === 'westpark') {
                    return `pin-${brand}-${bookability}-act`
                }

                return `pin-indigo-${bookability}-act`
            }

            return {
                label: location.name,
                value: normalize(location, locationSchema).result,
                type: constants.SUGGESTION_TYPE_PARKING_LOT,
                icon: getIcon(),
            }
        })
)

export const googleLocationsResultsSelector = createSelector(googleLocationsSelector, locations =>
    locations.map(location => ({
        label: location.description,
        value: location.place_id,
        type: constants.SUGGESTION_TYPE_GOOGLE_LOCATION,
        icon: 'pin-general',
    }))
)

export const combinedLocationsListSelector = createSelector(
    locationsListSelector,
    googleLocationsResultsSelector,
    (locations, googleLocations) => [...locations, ...googleLocations]
)

const idSelector = (state, props) => props.id

export const locationSelector = createDenormalizedSelector(idSelector, locationSchema)
export const googleLocationSelector = createDenormalizedSelector(idSelector, googleLocationSchema)

/* EVENTS */
export const eventsSearchSelector = state => state.eventsSearch
export const searchEventInputSelector = createSelector(eventsSearchSelector, search => search.searchEventInput)

export const eventsResultsSelector = createSelector(eventsSearchSelector, search => search.results)

export const eventsSearchPendingSelector = createSelector(
    pendingSelector,
    pending => pending.getParkingAllEvents || false
)

export const selectedEventSelector = createSelector(eventsSearchSelector, search => search.selectedEvent)
export const selectedEventLocationIdSelector = createSelector(selectedEventSelector, selectedEvent =>
    selectedEvent ? selectedEvent.locationId : null
)

export const eventsListSelector = createSelector(eventsResultsSelector, events =>
    events.map(event => ({
        ...event,
        label: event.eventName,
        value: event.eventId,
        icon: 'ticket',
        secondaryText: [event.eventStartDate, event.locationName],
        price: event.amount,
    }))
)
